import styled from 'styled-components';

export const Dialog = styled.dialog`
  position: fixed;
  animation: fade-slide-up 0.3s ease-out forwards;
  @keyframes fade-slide-up {
    from {
      opacity: 0;
      transform: translateY(4rem);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
